const Statistics = (props) => {
  const { icon, title, subtitle1, subtitle2, value1, value2, endContent } = props;
  return (
    <div className="flex flex-col w-full justify-between rounded-[20px] bg-white bg-clip-border px-4 py-2 shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
      {title && <h3 className="pb-2">{title}</h3>}
      <div className="flex justify-start items-center">
        {icon}
        <div className="flex divide-x gap-4">
          <div className="pl-4">
            <h5 className="text-sm font-medium leading-5 text-gray-600">
              {subtitle1}
            </h5>
            <p className="mt-1 text-xl font-bold leading-6 text-navy-700 dark:text-white">
              {value1}
            </p>
          </div>
          { value2 &&
            <div className="pl-4">
            <h5 className="text-sm font-medium leading-5 text-gray-600">
              {subtitle2}
            </h5>
            <p className="mt-1 text-xl font-bold leading-6 text-navy-700 dark:text-white">
              {value2}
            </p>
          </div>}
        </div>
      </div>

      {endContent}
    </div>
  );
};

export default Statistics;
